import { IProtocolo, IProtocoloKitDeOpmeV2, IProtocoloKitOpme } from '@/types/interfaces/protocolo/protocolo.interface';

export enum OrigemKitMateriais {
  Protocolo = 1,
  Medico = 2,
}

type StateKitV1 = {
  versao: 'v1';
  kits: IProtocoloKitOpme[];
};

type StateKitV2 = {
  versao: 'v2';
  kits: IProtocoloKitDeOpmeV2[];
};

type StateVersaoUndefined = {
  versao?: undefined;
  kits: [];
};

type BaseState = {
  protocolo?: IProtocolo;
  origem?: OrigemKitMateriais;
};

export type State = (StateKitV1 | StateKitV2 | StateVersaoUndefined) & BaseState;

export interface KitPersonalizado {
  id: string;
  descricao: string;
  opmes: {
    quantidade: number;
    opme: object;
    fornecedor1?: {
      id: string;
      nome: string;
    };
    fornecedor2?: {
      id: string;
      nome: string;
    };
    fornecedor3?: {
      id: string;
      nome: string;
    };
  }[];
}
